import React from 'react';
import Card from '../UI/Card';

const SecurityNotice: React.FC = () => {
  return (
    <Card className="p-4 bg-green-50 dark:bg-green-900/30 border-green-200 dark:border-green-700">
      <div className="flex items-center gap-2 text-green-700 dark:text-green-300">
        <div className="w-2 h-2 bg-green-500 rounded-full"></div>
        <span className="text-sm font-medium">Secure Payment</span>
      </div>
      <p className="text-xs text-green-600 dark:text-green-400 mt-1">
        Your payment information is encrypted and secure. All transactions are protected by industry-standard security protocols.
      </p>
    </Card>
  );
};

export default SecurityNotice;